import React from 'react';
import { Typography } from 'antd';
import { ComponentType, ComponentMode as Mode } from '@/shared/types';
import { Checkbox } from '@/shared/ui/checkbox';
import { Embedding } from '@/shared/ui/embedding';
import { Image } from '@/shared/ui/image';
import { Input } from '@/shared/ui/input';
import { Select } from '@/shared/ui/select';
import { Text } from '@/shared/ui/text';
import { TextArea } from '@/shared/ui/text-area';
import { Video } from '@/shared/ui/video';
import { ProcsComponentWrapper } from './ProcsComponentWrapper';

const { Text: TextAntd } = Typography;

const Components = {
  [ComponentType.Text]: Text,
  [ComponentType.Image]: Image,
  [ComponentType.Checkbox]: Checkbox,
  [ComponentType.Video]: Video,
  [ComponentType.Select]: Select,
  [ComponentType.Input]: Input,
  [ComponentType.TextArea]: TextArea,
  [ComponentType.Embedding]: Embedding,
};

type Props = {
  block: any;
  mode: Mode;
  index: number;
  stepId?: string;
};

export const ProcsComponentsRenderer = ({
  block,
  mode,
  stepId,
  index,
}: Props) => {
  // component does exist
  if (
    typeof Components[block.component as keyof typeof Components] !==
    'undefined'
  ) {
    const Component = Components[block.component as keyof typeof Components];

    switch (mode) {
      case Mode.Edit:
        return (
          <ProcsComponentWrapper key={block.id} block={block} index={index}>
            <Component {...block} mode={Mode.Edit} />
          </ProcsComponentWrapper>
        );

      case Mode.Preview:
        return <Component key={block.id} {...block} mode={Mode.Preview} />;

      case Mode.Input:
        return (
          <Component
            {...block}
            key={block.id}
            stepId={stepId}
            mode={Mode.Input}
          />
        );

      case Mode.Disabled:
        return (
          <Component
            {...block}
            key={block.id}
            stepId={stepId}
            mode={Mode.Disabled}
          />
        );

      default:
        throw new Error('Invalid component mode provided to Components.tsx');
    }
  }
  // component doesn't exist yet
  return React.createElement(
    () => (
      <TextAntd>
        The component {block.component} has not been created yet.
      </TextAntd>
    ),
    { key: block.id },
  );
};
